import './Footer.scss';

const Footer = () => {
    return (
        <footer className="footer flex-column small-gap">
            <div className="line"></div>
            <div className="flex-row medium-gap">
                <p>© 2025 New Park Times</p>
                <a href="https://www.linkedin.com/in/parker-anderson-baab0820a" rel="noopener noreferrer" target="_blank">LinkedIn</a>
                <a href="https://github.com/parkeranderson130" rel="noopener noreferrer" target="_blank">GitHub</a>
                <a href="https://drive.google.com/file/d/1qdanfjeTAxatYW1Dtb1fuG3fH09gg0k2/view" rel="noopener noreferrer" target="_blank">Resume</a>
            </div>
        </footer>
    )
}

export default Footer;